module.exports = __webpack_public_path__ + "img/slider.e6984095.jpg";